import { render, staticRenderFns } from "./factoryManageFrame.vue?vue&type=template&id=1a72a84d&scoped=true"
import script from "./factoryManageFrame.vue?vue&type=script&lang=js"
export * from "./factoryManageFrame.vue?vue&type=script&lang=js"
import style0 from "./factoryManageFrame.vue?vue&type=style&index=0&id=1a72a84d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72a84d",
  null
  
)

export default component.exports